var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"child-vetable"},[_c('ve-table',{attrs:{"id":"tb","columns":_vm.columns,"table-data":_vm.tableData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }